import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FacilityAdmin } from '@umss/shared/data-access';

@Injectable({
  providedIn: 'root',
})
/**
 * @deprecated
 */
export class AdminService {
  private getApiUrl(facilityId: string) {
    return `/api/facilities/${facilityId}/admins`;
  }

  constructor(private http: HttpClient) {}

  /**
   * Fetch all admins for a facility.
   * @param facilityId The ID of the facility.
   * @returns An Observable array of FacilityAdmins.
   */
  getAdmins(facilityId: string): Observable<FacilityAdmin[]> {
    return this.http.get<FacilityAdmin[]>(this.getApiUrl(facilityId));
  }

  /**
   * Add a new admin to a facility.
   * @param facilityId The ID of the facility.
   * @param adminData The data for the new admin.
   * @returns An Observable of the created FacilityAdmin.
   */
  addAdmin(
    facilityId: string,
    adminData: Partial<FacilityAdmin>
  ): Observable<FacilityAdmin> {
    return this.http.post<FacilityAdmin>(this.getApiUrl(facilityId), adminData);
  }

  /**
   * Update an existing admin.
   * @param facilityId The ID of the facility.
   * @param adminId The ID of the admin to update.
   * @param adminData The partial data to update.
   * @returns An Observable of the updated FacilityAdmin.
   */
  updateAdmin(
    facilityId: string,
    adminId: string,
    adminData: Partial<FacilityAdmin>
  ): Observable<FacilityAdmin> {
    return this.http.put<FacilityAdmin>(
      `${this.getApiUrl(facilityId)}/${adminId}`,
      adminData
    );
  }

  /**
   * Send a password reset email to an admin.
   * @param facilityId The ID of the facility.
   * @param adminId The ID of the admin.
   * @returns An Observable that completes when the operation is done.
   */
  resetPassword(facilityId: string, adminId: string): Observable<void> {
    return this.http.post<void>(
      `${this.getApiUrl(facilityId)}/${adminId}/reset-password`,
      {}
    );
  }

  /**
   * Terminate an admin's access.
   * @param facilityId The ID of the facility.
   * @param adminId The ID of the admin to terminate.
   * @param terminationData The details of the termination.
   * @returns An Observable of the updated FacilityAdmin.
   */
  terminateAdmin(
    facilityId: string,
    adminId: string,
    terminationData: {
      terminationDate: string;
      reason: string;
      rehireEligible: boolean;
    }
  ): Observable<FacilityAdmin> {
    return this.http.put<FacilityAdmin>(
      `${this.getApiUrl(facilityId)}/${adminId}/terminate`,
      terminationData
    );
  }
}
